import React from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import propTypes from 'prop-types';
import { StyledButton } from '../../../Components/Generics.styled';
import { useHistory } from 'react-router-dom';

const LandingPageCreatedContainer = styled.div`
    display: flex;
    height: 700px;
    width: 800px;
    margin-left: auto;
    margin-right: auto;
    flex-direction: column;
`;

const Title = styled.div`
    font-size: 23px;
    font-weight: bold;
    margin-top: 80px;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    width: 700px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    margin-bottom: 50px;
`;
const LeadGeneratorContainer = styled.div`
    display: flex;
    margin-top: 12px;
    flex-direction: column;
    text-align: center;
`;

const IframeSection = styled.div`
    display: flex;
    margin-top: 12px;
    flex-direction: column;
    text-align: center;
`;

const StyledNavButtons = styled.div`
    margin-top: 30px;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 270px;
    margin-left: auto;
    margin-right: auto;
`;
const LandingPageCreated = (props) => {
    const { handleNavButtonBack, leadGenerationData } = props;
    const history = useHistory();
    const { _id } = { ...leadGenerationData };

    return (
        <LandingPageCreatedContainer>
            <Title>Congratulations, your landing page has been created!</Title>
            <LeadGeneratorContainer>
                You can access your landing page at{' '}
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`https://${leadGenerationData.subdomain}.lifewiseleads.com/`}
                >
                    https://{leadGenerationData.subdomain}.lifewiseleads.com/
                </a>
                {/* <br /> */}
                <IframeSection>
                    To embed your landing page into your own website, copy and paste the code below.
                    <div
                        style={{
                            border: '1px solid black',
                            width: '400px',
                            height: '270px',
                            marginLeft: 'auto',
                            marginRight: 'auto',
                            marginTop: '10px',
                        }}
                    >
                        <div style={{ textAlign: 'left', padding: '16px', fontSize: '18px' }}>
                            <code>
                                {'<iframe '}
                                <br />
                                {`src=https://${leadGenerationData.subdomain}.lifewiseleads.com/embedded`}
                                <br />
                                {'title="Lifewise Leads Form Generator"'}
                                <br />
                                {'scrolling="no"'}
                                <br />
                                {'frameborder="0"'}
                                <br />
                                {'width="640px"'} <br />
                                {'height="480px"'}
                                <br />
                                {' ></iframe>'}
                            </code>
                        </div>
                    </div>
                </IframeSection>
                <br />
                <div style={{ fontWeight: 'bold' }}>
                    Create one or more campaigns to drive traffic
                </div>
            </LeadGeneratorContainer>
            <StyledNavButtons>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleNavButtonBack()}
                >
                    Back
                </StyledButton>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => history.push('/portal/campaign/createACampaign')}
                >
                    Create a Campaign
                </StyledButton>
            </StyledNavButtons>
        </LandingPageCreatedContainer>
    );
};
LandingPageCreated.propTypes = {
    handleNavButtonBack: propTypes.func,
    leadGenerationData: propTypes.shape({
        subdomain: propTypes.string,
    }),
};

LandingPageCreated.defaultProps = {
    handleNavButtonBack: () => {},
};
export default LandingPageCreated;
